import styled from '@emotion/styled';
import React, { PropsWithChildren } from 'react';
import { useDesktopMediaQuery } from '../../../../hooks';

export const MobileVerticallyPaddedContainer = ({
  children
}: PropsWithChildren<unknown>) => {
  const isMobile = !useDesktopMediaQuery();

  return <MobilePadded isMobile={isMobile}>{children}</MobilePadded>;
};

const MobilePadded = styled.div<{
  isMobile: boolean;
}>`
  padding: ${(props) => (props.isMobile ? '32px 0' : '0')};
`;
